import { SelectionDropdown } from "@libs/zapi-ui/custom";
import { EVENT_OPTIONS } from "../const/const";

type TEventSelectProps = {
  event: string;
  setEvent: (event: string) => void;
};

export function EventSelect({ event, setEvent }: TEventSelectProps) {
  return (
    <div className="space-y-2 w-[180px]">
      <SelectionDropdown
        placeholder="All Events"
        options={EVENT_OPTIONS}
        value={event}
        onChange={(v) => {
          setEvent(v);
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
